import styled from 'styled-components';

export const CenteredText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
